import AnalyticsHelper from 'utils/AnalyticsHelper'
import CloudEvent from 'utils/CloudEvent'
import { useUserProfile } from 'core/hooks/data/useDataHook'
import useAuth from 'core/hooks/auth/useAuth'

const useUserAnalytics = () => {
  const { isAuthenticated } = useAuth()

  useUserProfile({
    opts: {
      enabled: isAuthenticated,
      onSuccess: (user) => {
        const properties: Record<string, unknown> = {}
        const userRoles = user.teams?.[0]?.roles

        const hasSentClientInvites = !!user.received_invites?.filter(
          (invite) => invite?.type === 'InviteClient'
        ).length

        const hasSentAccountantInvites = !!user.sent_invites?.filter(
          (invite) => invite?.type === 'InviteAccountant'
        ).length

        const hasSentManagerInvites = !!user.sent_invites?.filter(
          (invite) => invite?.type === 'InviteManager'
        ).length

        properties[CloudEvent.Premium] = !!user.subscription
        properties[CloudEvent.Email] = user.email
        properties[CloudEvent.Phone] = user.mobile
        properties[CloudEvent.FirstName] = user.name
        properties[CloudEvent.LastName] = user.last
        properties[CloudEvent.Vehicles] = user?.vehicles?.length || 0
        properties[CloudEvent.FavoritePlaces] = user?.places?.length || 0
        properties[CloudEvent.FavoriteTrips] = user?.favorite_trips?.length || 0
        properties[CloudEvent.FreeTripsRemaining] = user.free_trips_remaining
        properties[CloudEvent.TrialDaysRemaining] = user.trial_days_remaining
        properties[CloudEvent.InstitutionUserCount] =
          user.institution_users && user.institution_users.length
        properties[CloudEvent.BluetoothDeviceCount] =
          user.devices && user.devices.length
        properties[CloudEvent.HasReceivedInviteClient] = hasSentClientInvites
        properties[CloudEvent.HasSentInviteAccountant] =
          hasSentAccountantInvites
        properties[CloudEvent.HasSentInviteManager] = hasSentManagerInvites
        properties[CloudEvent.ClientUser] = user.group_as_client != null
        properties[CloudEvent.AccountantUser] = user.group_as_accountant != null
        properties[CloudEvent.Accountant] = user.group_as_accountant != null

        if (user.income_sources && user.income_sources.length > 0) {
          properties[CloudEvent.IncomeSources] = user.income_sources
        }
        if (user.program?.program_type) {
          properties[CloudEvent.ProgramType] = user.program.program_type
        }

        // Braze specific properties
        properties[CloudEvent.ExternalId] = user.token_id

        properties[CloudEvent.VerificationStatus] = user.verification_status
        properties[CloudEvent.FavoriteTransactions] =
          user?.favorite_transactions?.length || 0
        properties[CloudEvent.MonthlyReportEnabled] =
          user.monthly_report_enabled
        properties[CloudEvent.TotalUnclassifiedTrips] =
          user.total_uncategorized_trips_count

        if (userRoles?.length) {
          properties[CloudEvent.TeamRoles] = userRoles.map(({ name }) => name)
        }
        if (user.persona && user.persona.length > 0) {
          properties[CloudEvent.Persona] = user.persona
        }
        AnalyticsHelper.identify(user)
        AnalyticsHelper.addPeopleProperty(user.token_id, properties, true)
        AnalyticsHelper.trackEvent(CloudEvent.DashboardLoadUser)
      }
    }
  })

  return null
}

export default useUserAnalytics
